import React from "react";

const BlogCategory = ({ date, title, description, imgSrc }) => {
  return (
    <>
      <div className="vertical-blogs">
        <div className="vertical-blo-image">
          <img src={imgSrc} />
        </div>
        <div className="vertical-blog-title">
          <p>{date}</p>
          <h4>{title}</h4>
          <h5>{description}</h5>
        </div>
      </div>
    </>
  );
};

export default BlogCategory;
